import {goBack} from '@/utils';
import React from 'react';
import {TouchableOpacity} from 'react-native';
import theme from '@style';
import Text from '@basicComponents/text';
import {useInnerStyle} from '../proxy.hooks';
import i18n from '@/i18n';
import {BackIcon} from '../svg.variable';
// import {ruleHeaderImage} from '../proxy.variable';
import styles from './index.module.scss';

const ProxyRulesHeader = () => {
  const {rulesStyle} = useInnerStyle();
  return (
    <div
      style={{
        ...theme.fill.fillW,
        ...theme.flex.row,
        ...theme.flex.center,
        ...theme.position.rel,
        ...rulesStyle.header,
        zIndex: 2,
        position: 'sticky',
        // backgroundImage: `url(${ruleHeaderImage})`,
      }}
      className={styles.rule_header}>
      <TouchableOpacity
        onPress={() => goBack()}
        style={[theme.position.abs, rulesStyle.headerBack]}>
        <BackIcon
          width={theme.iconSize.l}
          height={theme.iconSize.l}
          stroke={theme.basicColor.white}
        />
      </TouchableOpacity>
      <Text fontSize={theme.fontSize.l} blod color={theme.basicColor.white}>
        {i18n.t('proxy.rules.header')}
      </Text>
    </div>
  );
};

export default ProxyRulesHeader;
